import man1 from './man1.jpg';
import man2 from './man2.jpg';
import woman1 from './woman1.jpg';
import woman2 from './woman2.jpg';
import woman3 from './woman3.jpg';
import line from './line.png';

export * from './services'
export { man1, man2, woman1, woman2, woman3, line }